import React, { useCallback, useEffect, useState } from "react";
import { DocumentIcon, PersonSvg } from "../../assets/common-svg/CommonSvg";
import { CustomWrapperCard } from "../../components/custom-product-cards/custom-wrapper-card/CustomWrapperCard";
import CustomDetailComponent from "../../components/doctor-detail-component/DocotorDetail";
import TrialInfoComponent from "../../components/trial-info-component/TrialInfoComponent";
import CustomTable from "../../components/custom-table/CustomTable";
import { useLocation, useNavigate } from "react-router";
import { Typography, useTheme } from "@mui/material";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import {
  principleInvestigatortDetailData,
  userManagementDetailData,
} from "../../utils/tableData";
import SkeltonLoaderHeader from "../../utilites/SkeltonLoaderHeader";
import NoDataCard from "../../components/no-data-card.js";
import { useDispatch } from "react-redux";
import SubjectApi from "../../services/subjectService.js";
import { setPhaseDetail } from "../../store/reducers/phase-reducer.js";
import PhaseApi from "../../services/phase.js";
import SubAdminApi from "../../services/subAdminService.js";
import CustomSearchbar from "../custom-searchbar/CustomSearchbar.js";
import { useSearchParams } from "react-router-dom";
import moment from "moment";
import { notify } from "../../bmr/utils/methods/notification.js";
import CustomDrawer from "../../components/custom-drawer/CustomDrawer.js";
import HeaderBackNav from "../../components/header-back-navigation/HeaderBackNav.js";
import CustomTabs from "../custom-tabs/CustomTabs.js";
import { EditSubjectPhase, ReAssignPiEditor } from "../../utils/formik/initialValues.js";
import CustomAccordion from "../custom-accordion/CustomAccordion.js";
export const convertSubjectData = (data, moduleName, curr_page, order, page_details) => {
  const moduleConfig = {
    UserManagement: [
      "serial_number",
      "patient_id",
      "full_name", // Placeholder for concatenated first and last name
      "patient_status",
       "last_visit_type",
      "investigatorDetails.name",
      "added_by",
      "editor",
      "cycle",
      "gender",
      "last_appointment_date",
      "role",
      "hospital",
      "id",
    ],
    PI: ["serial_number", "patient_id", "full_name", "patient_status", "last_visit_type", "added_by", "editor", 'cycle', "gender", "last_appointment_date", "role", "id"],
  };

  const fields = moduleConfig[moduleName];

  return data?.map((sub, index) => {
    // Extract editor data for drawer
    let editorData = [];
  
       if (sub?.userPi?.length) {
      editorData = sub.userPi.map(pi => ({
        id: pi.id,
        name: pi.name,
        role: pi.role_title,
      }));
    }

    const transformedEditorCount = (editorData.length > 1) 
  ? editorData.length.toString() 
  : (editorData.length === 1) 
    ? editorData[0]?.name || "--" 
    : "--";


    const displayData = fields.map((field) => {
      if (field === "full_name") {
        const firstName = sub.first_name ?? "Not Assigned";
        const lastName = sub.last_name ?? "";
        return `${firstName} ${lastName}`.trim();
      } else if (field === "patient_status") {
        return sub?.life_status == "lost" ? (
          <div className="h-3 w-3 rounded-full bg-yellow-500"></div>
        ) : sub?.life_status == "alive" ? (
          <div className="h-3 w-3 rounded-full bg-green-500"></div>
        ) : (
          <div className="h-3 w-3 rounded-full bg-red-500"></div>
        );
      } else if (field === "patient_id") {
        return sub?.patient_id || "--";
      } else if (field == "last_visit_type") {
        return sub?.last_visit_type || "--";
      } else if (field == "last_appointment_date") {
        return sub?.last_appointment_date ? moment(sub?.last_appointment_date).format("DD/MM/YYYY") : "--";
      } else if (field == "added_by") {
        return sub?.created_By?.name || "--";
      } else if (field == "editor") {
        return transformedEditorCount;
      } else if (field == "role") {
        return sub?.created_By?.role_details?.title || "--";
      } else if (field == "hospital") {
        return sub?.hospitalDetails?.name || "--";
      } else if (field === "serial_number") {
        let SerialNo = order == 'desc' ? (page_details?.no_of_records - ((curr_page - 1) * 10)) - index : index + 1 + ((curr_page - 1) * 10);
        return SerialNo;
      } else {
        const fieldParts = field.split(".");
        return fieldParts.reduce((acc, part) => acc?.[part] ?? "Not Assigned", sub);
      }
    });

    return {
      displayData,
      internalData: {
        editorData,
        rowId: sub?.id,
        originalData: sub
      }
    };
  });
};

const PhaseListDetail = ({ id, roleId = "", moduleName, ShowEditorCount }) => {
  const [activeTab, setActiveTab] = useState(null);
  const [phaseDetailLoading, setPhaseDetailLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [phaseListData, setPhaseListData] = useState(null);
  const [phaseListDetails, setPhaseListDetails] = useState({});
  const [phaseListLoading, setPhaseListLoading] = useState(false);
  const [editorList, setEditorList] = useState([]);
  const [expand, setExpanded] = useState(null);
  const [setOpenDeleteModal] = useState(false);
  const [setInitialValues] = useState(ReAssignPiEditor);
  const [setRowId] = useState(null);
  const [setOpenAddSubjectModal] = useState(false);
  const [subjectData, setSubjectData] = useState(
    moduleName === "UserManagement"
      ? userManagementDetailData
      : moduleName === "PI"
        ? principleInvestigatortDetailData
        : {}
  );
  const [setPatientEdit] = useState({
    ...EditSubjectPhase,
    investigator_id: "",
    editor_id: ""
  });
  const [subjectListData, setSubjectListData] = useState([]);
  const [tableFilters, setTablesFilters] = useState({ searchData: "" });
  const [totalPage, setTotalPage] = useState(1);
  const [currentPage, setCurrentpage] = useState(1);
  const [pIList, setPIList] = useState([]);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [piId, setPiID] = useState(null);
  const [editorId, setEditorId] = useState(null);
  const [searchParams] = useSearchParams();

  const [openEditorDrawer, setOpenEditorDrawer] = useState(false);
  const [editorDrawerData, setEditorDrawerData] = useState([]);
  const [editorSearch, setEditorSearch] = useState("");

  const activeTrialId = searchParams.get('phase_id');
  const handleNavigateToDetails = useCallback((row) => {
    const rowIndex = getRowIndex(row);
    if (!subjectListData || !subjectListData[rowIndex]) {
      console.log("No subject data available");
      return;
    }

    const internalData = subjectListData[rowIndex]?.internalData;
    const patientId = internalData?.rowId;

    const UpdatedNavigationArray = location.state || [];
    UpdatedNavigationArray?.push({
      name: "Patient Details",
      path: `${location.pathname}/patient-details/${patientId}`,
    });

    navigate(`patient-details/${patientId}`, {
      state: UpdatedNavigationArray,
    });
  }, [subjectListData, location, navigate]);

  const getRowIndex = (row) => {
    return subjectData?.rows?.indexOf(row) ?? -1;
  };

  // UPDATED: Add handleCellClick function for editor column
  const handleCellClick = (row, columnIndex) => {
    const rowIndex = getRowIndex(row);
    if (!subjectListData || !subjectListData[rowIndex]) {
      console.log("No subject data available");
      return;
    }

    const internalData = subjectListData[rowIndex]?.internalData;

    let editorColumnIndex;
    if (moduleName === "UserManagement") {
      editorColumnIndex = 7;
    } else if (moduleName === "PI") {
      editorColumnIndex = 6; 
    } else {
      editorColumnIndex = 7; 
    }

    if (columnIndex === editorColumnIndex) {
      const editorData = internalData?.editorData || [];
      if (editorData.length > 0) {
        setEditorDrawerData(editorData);
        setOpenEditorDrawer(true);
      } else {
        // notify.info("No Editor assigned");
      }
    }
  };

  const filteredEditorDrawerData = editorDrawerData.filter(editor =>
    (editor.name?.toLowerCase() || "").includes(editorSearch.toLowerCase()) ||
    (editor.email?.toLowerCase() || "").includes(editorSearch.toLowerCase()) ||
    (editor.role?.toLowerCase() || "").includes(editorSearch.toLowerCase())
  );

  const handlePhaseSearch = (value) => {
    resetSortFilter();
    if (value !== " ") {
      getPhaseList(value);
    }
  };
 
  async function getPhaseList(search = "", limit = 100, page = 1) {
    setPhaseListLoading(true);
    setLoading(true);
    try {
      const res = await PhaseApi.getPhaseList(
        "",
        search,
        limit,
        page,
        id,
        roleId
      );
      setPhaseListData(res.data || []);
      if (res?.data?.length > 0) {
        setActiveTab(activeTrialId || res.data[0].id);
      } else {
        setActiveTab(null);
      }
    } catch (error) {
      notify.error(error);
    } finally {
      setPhaseListLoading(false);
      setLoading(false);
    }
  }

  useEffect(() => {
    getPhaseList();
  }, []);

  useEffect(() => {
  if (phaseListDetails?.id) {
      if (
        tableFilters?.searchData[tableFilters?.searchData?.length - 1] != " "
      ){
   setLoading(true);
    getSubjectList();
      }
  }
}, [currentPage, tableFilters, phaseListDetails, piId, editorId, id]);

  useEffect(() => {
    setPiID(null);
    setEditorId(null);
    if (activeTab) {
      (async function () {
        setPhaseDetailLoading(true);
        try {
          const res = await PhaseApi.getPhaseListDetails(activeTab, id);
          setPhaseListDetails(res.data || []);
          dispatch(setPhaseDetail(res.data));
        } catch (error) {
          notify.error(error?.message || error);
        } finally {
          setPhaseDetailLoading(false);
        }
      })();
    }
  }, [activeTab]);

  const getEditorForSubjectSubAdmin = async (value) => {
    try {
      return await SubAdminApi.getEditorForSubjectSubAdmin(
        value,
        phaseListDetails?.id,
        id
      );
    } catch (error) {
      notify.error(error?.message || error);
    }
  };

  useEffect(() => {
    const fetchEdiorData = async () => {
      const results = await Promise.allSettled([
        getEditorForSubjectSubAdmin(2),
        getEditorForSubjectSubAdmin(5),
      ]);

      results?.forEach((result, index) => {
        if (result.status === "fulfilled") {
          const data = result.value?.data || [];
          switch (index) {
            case 0:
              setPIList(data);
              break;
            case 1:
              setEditorList(data);
              break;
            default:
              break;
          }
        } else {
          console.error(
            `Error fetching data for index ${index + 2}:`,
            result.reason
          );
        }
      });
    };
    if (phaseListDetails?.id) {
      fetchEdiorData();
    }
  }, [phaseListDetails]);

  const GetMatchedKey = (key) => {
    switch (key.trim().toLowerCase()) {
      case 's.no':
        return 'created_at';
      case 'patient id':
        return 'patient_id';
      case 'patient name':
        return 'name';
      case 'patient status':
        return 'life_status';
      case 'last recorded visit':
        return 'last_visit_type';
      case 'investigator':
        return 'investigator';
      case 'principal investigator':
        return 'investigator';
      case 'editor':
        return 'editor';
      case 'cycle no.':
        return 'cycle';
      case 'phase':
        return 'phase_name';
      case 'appointment completed':
        return 'appointmentCount';
      default:
        return '';
    }
  };

  async function getSubjectList() {
    const sortBy = GetMatchedKey(orderBy);
    try {
      const res = await SubjectApi.getSubjectList(
        phaseListDetails?.id,
        currentPage,
        10,
        tableFilters?.searchData,
        editorId,
        (moduleName === "PI") ? id : piId,
        "",
        "",
        sortBy,
        order,
        id,
        "", 
        "", 
        "", 
        (moduleName === "PI") ? id : piId,
      );

      const convertedData = convertSubjectData(res?.data || [], moduleName, currentPage, order, res?.page_details);
      const rowData = convertedData.map(item => item.displayData);
      setSubjectListData(convertedData);
      setSubjectData((prev) => ({
        ...prev,
        rows: [...rowData],
      }));

      setTotalPage(
        Math.ceil(res?.page_details?.no_of_records / res?.page_details?.limit)
      );

      setCurrentpage(res?.page_details?.page);
      setLoading(false);
    } catch (error) {
      notify.error(error?.message || error);
    }
  }

  const handlePagination = async (value) => {
    setCurrentpage(value);
  };

  const handleTableFilters = (e) => {
    setTablesFilters({ ...tableFilters, searchData: e });
    setCurrentpage(1);
  };

  const handleDropDownChange = (e, id) => {
    setCurrentpage(1);
    if (id === "selectPI") {
      setPiID(e.target.value);
    } else if (id === "editorList") {
      setEditorId(e.target.value);
    }
  };

  const handleSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  useEffect(() => {
    if (orderBy) {
      getSubjectList();
    }
  }, [orderBy, order]);

  const resetSortFilter = () => {
    if (order == 'desc') {
      setOrder('asc');
    }
    if (orderBy) {
      setOrderBy('');
    }
  };
  const handleExpand = (panelId) => {
  setExpanded(prev => (prev === panelId ? null : panelId));
};
    const handleOpenAddSubjectModal = async () => {
      if (phaseListDetails?.investigator_details?.investigator_id?.length == 0) {
        notify.error("You can't add patient until PI is not added for phase !");
        return;
      }
      setInitialValues({
        investigator_id: "",
        editor_id: "",
      });
      setRowId(null);
      setOpenAddSubjectModal(true);
      setPatientEdit({
        ...EditSubjectPhase,
        investigator_id: "",
        editor_id: ""
      });
      const principalInvestigators = phaseListDetails?.investigator_details?.principal_investigator || [];
      if (principalInvestigators.length > 0) {
        const firstPiId = principalInvestigators[0].id;
        setPatientEdit(prev => ({
          ...prev,
          investigator_id: firstPiId
        }));
      }
    }
  const handleEdit = useCallback(() => {
    const UpdatedNavigationArray = location.state;
    UpdatedNavigationArray?.push({
      name: "Edit Details",
      path: `${location.pathname}/edit-trial-details/${phaseListDetails?.id}`,
    });
    navigate(`edit-trial-details/${phaseListDetails?.id}`, {
      state: UpdatedNavigationArray,
    });
  }, [phaseListDetails?.id]);
  const handleDelete = () => {
    setOpenDeleteModal(true);
  };
   const handlePhaseTabChange = (phaseId) => {
    setActiveTab(phaseId);
    setCurrentpage(1);
  };

  return (
    <div className="pt-4 pb-4 relative">
            <div className="pb-3 w-[400px]">
            <CustomSearchbar
              width={"100%"}
              BgColor={"#FFFFFF"}
              Placeholder={"Search by Name"}
              handleSearch={handlePhaseSearch}
            />
            </div>
      {loading ? (
             <div className="pt-3">
      <SkeletonLoader
      variant="rectangular"
      height={400}
      sx={{ borderRadius: 2 }}
     />
     </div>
) : !phaseListData || phaseListData.length === 0 ? (
  <div className="col-start-4 col-end-13">
    <NoDataCard heading="Phase does not exist" />
  </div>
) : (
<>
                <div className="pt-3">
        <CustomTabs
          phases={phaseListData}
          activePhaseId={activeTab}
          onPhaseChange={handlePhaseTabChange}
          onAddPatient={handleOpenAddSubjectModal}
          onEditPhase={handleEdit}
          onDeletePhase={handleDelete}
          loading={phaseListLoading}
          phaseDetails={phaseListDetails}
        />
        </div>  
        <div className="col-start-4 col-end-13 min-h-[25rem] bg-[#FFFFFF] rounded-xl">
            {phaseDetailLoading || phaseListLoading ? (
              <SkeltonLoaderHeader
                rowCount={2}
                width={200}
                height={30}
              />
            ) : (
              <CustomWrapperCard
                data={phaseListDetails || {}}
                editDeleteBtn={false}
                title={"Total Editors"}
                ShowEditorCount={ShowEditorCount}
              />
            )}
            {/* <hr className="ml-[1rem] mr-[1rem]" /> */}

            <TrialInfoComponent
              HeaderTitle={"Description"}
              ShowHeaderButton={false}
            >
              {phaseDetailLoading || phaseListLoading ? (
                <SkeletonLoader
                  rowCount={1}
                  isTable={false}
                  width={500}
                  height={20}
                />
              ) : (
                <Typography variant="p" className="break-words">
                  {(phaseListDetails?.description?.[0]?.toUpperCase() +
                    phaseListDetails?.description?.slice(1)) || "No Description Added"}
                </Typography>
              )}
            </TrialInfoComponent>

<CustomAccordion
                            accordionClassName={"w-100"}
                            rootDivClass={"pb-3"}
                            expanded={phaseListDetails?.form_details?.length!==0 &&expand === "assignedForms"}
                            handleExpansion={() => {
                              if(phaseListDetails?.form_details?.length!==0){handleExpand("assignedForms")}}}
                            noBorderDetail={true}
                            title={phaseListDetails?.form_details?.length===0?"Assigned Forms(No Assigned Forms Found)":"Assigned Forms"}
                            disabled={phaseListDetails?.form_details?.length===0}
                          >
            <TrialInfoComponent
              ShowHeaderButton={false}
            >
              <div className="flex gap-2 justify-start flex-wrap">
                {phaseDetailLoading || phaseListLoading ? (
                  <SkeletonLoader
                    rowCount={2}
                    isTable={false}
                    width={200}
                    height={30}
                  />
                ) : (
                  <>
                    {phaseListDetails?.form_details?.length > 0
                      ? phaseListDetails?.form_details?.map((item) => (
                          <CustomDetailComponent
                            key={item?.id || ""}
                            BgColor="#2831720D"
                            FirstHeading={item.title || ""}
                            Icon={<DocumentIcon LightBlue={true} />}
                            ShowDeleteIcon={false}
                          />
                        ))
                        : "No Assigned Form Found."}
                  </>
                )}
              </div>
            </TrialInfoComponent>
            </CustomAccordion>

            <div className="p-3">
              <CustomTable
                SearchbarBgColor="secondary"
                rows={subjectData?.rows}
                columnAlign={subjectData?.columnAlign}
                columns={subjectData?.columns}
                handleTableFilters={handleTableFilters}
                tableFilters={tableFilters}
                handleChangePage={handlePagination}
                loading={loading}
                currentPage={currentPage}
                totalpage={totalPage}
                handleChangeDropDown={handleDropDownChange}
                handleNavigate={handleNavigateToDetails}
                DropdownBgColor={theme?.palette?.grey[200]}
                order={order}
                orderBy={orderBy}
                EnableSorting={true}
                handleSort={handleSort}
                handleCellClick={(row, columnIndex) => {
                  handleCellClick(row, columnIndex);
                }}
                TableData={{
                  ...subjectData?.TableData,
                  filters: subjectData?.TableData?.filters?.map((item) => {
                    if (item?.id === "editorList") {
                      return {
                        ...item,
                        MenuList: editorList,
                        dropDownValue: editorId,
                      };
                    } else if (item?.id === "selectPI") {
                      return {
                        ...item,
                        MenuList: pIList,
                        dropDownValue: piId,
                      };
                    }
                    return item;
                  }),
                }}
                
              />
            </div>
            </div>
         </>
        )}
      {/* </div>    */}

      {openEditorDrawer && (
        <CustomDrawer open={openEditorDrawer} toggleDrawer={() => setOpenEditorDrawer(!openEditorDrawer)}>
          <div className="w-[25rem]">
            <div className="pl-4 pt-4 pr-4">
              <HeaderBackNav
                handleBackNav={() => setOpenEditorDrawer(false)}
                TitleFontSize={"18px"}
                TitleFontWeight={700}
                Title="Editor/Project Manager Details"
              />
            </div>
            <hr />
            <div className="pl-3 pt-3 pr-3">
              <CustomSearchbar
                Placeholder="Search by Name or Role"
                BgColor="#dfe0eb"
                value={editorSearch}
                handleSearch={(value) => setEditorSearch(value)}
              />
              <ul className="p-2 cursor-pointer">
                {loading ? (
                  <SkeletonLoader rowCount={1} height={"35px"} />
                ) : filteredEditorDrawerData?.length === 0 ? (
                  <div className="mt-4">
                    <Typography variant="body1" className="text-center text-gray-500">
                      No editor details available
                    </Typography>
                  </div>
                ) : (
                  filteredEditorDrawerData?.map((editor, index) => (
                    <li
                      key={editor?.id || index}
                      className="flex gap-3 align-center pt-2 pb-2"
                      style={{ borderBottom: "2px solid #dfe0eb" }}
                    >
                      <div className="self-center">
                        <PersonSvg />
                      </div>
                      <div className="self-center">
                        <Typography variant="h6">
                          {editor?.name || "Name not available"}
                        </Typography>
                        {editor?.role && (
                          <Typography variant="body2" color="textSecondary">
                            Role: {editor.role}
                          </Typography>
                        )}
                      </div>
                    </li>
                  ))
                )}
              </ul>
            </div>
          </div>
        </CustomDrawer>
      )}
    </div>

                                                                   
  );
};

export default PhaseListDetail;